import React from 'react';
import GradientText from './gradient-text';
import { cn } from '@/shadcn-ui/utils';

interface ListWithIconsItem {
  icon: React.ReactNode;
  title: string;
  titleClassName?: string;
  description?: string;
  descriptionClassName?: string;
  inline?: boolean;
  variantDescription?: 'default' | 'gradient';
  textGap?: number;
}

interface ListWithIconsProps {
  items: ListWithIconsItem[];
  variant?: 'default' | 'gradient';
  className?: string;
}

export default function ListWithIcons({
  items,
  variant = 'default',
  className,
}: ListWithIconsProps) {
  return (
    <ul className={cn('m-0 flex flex-col gap-[16px]', className)}>
      {items.map((item, index) => (
        <li key={index} className="flex gap-[8px]">
          {item.icon}
          <div
            className={cn('gap-[4px]', {
              'inline-flex': item.inline,
              'flex flex-col': !item.inline,
              [`gap-[${item.textGap}px]`]: item.textGap !== undefined,
            })}
          >
            {variant === 'gradient' ? (
              <GradientText variant="body2-strong" className={item.titleClassName}>
                {item.title}
              </GradientText>
            ) : (
              <p className={cn('body2-strong', item.titleClassName)}>{item.title}</p>
            )}
            {item.description ? (
              item.variantDescription === 'gradient' ? (
                <GradientText
                  variant="body2-strong"
                  from="#00FFCD -45.4%"
                  to="#2A00A5 100%"
                  className={item.descriptionClassName}
                >
                  {item.description}
                </GradientText>
              ) : (
                <p className={cn('body2', item.descriptionClassName)}>
                  {item.description}
                </p>
              )
            ) : null}
          </div>
        </li>
      ))}
    </ul>
  );
}
